// @flow

export const getActiveWidget = state => state.widget
